export default __webpack_public_path__ + "static/media/Icon_elimina.6f014e6b.svg";